// extracted by mini-css-extract-plugin
module.exports = {"stepperCompleted":"#3dd3af","stepperActive":"#313e49","stepperTextColor":"#fff"};